export default __webpack_public_path__ + "static/media/microsoft.8b75f241.png";